import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { EMPTY_DASH, prettyMoney } from '@scramble/utils';
import IconChevron from "@scramble/design-system/icons/chevron-up.svg";
import s from './index.module.scss';

export const AllocationInfo = ({
  allocatedGroupA,
  allocatedGroupB,
  totalAllocated = 0,
  bonusAmount = 0
}) => {
  const { t } = useTranslation();
  const [hide, setHide] = useState(true);
  const bonusInGroupA = Math.min(bonusAmount, allocatedGroupA);
  const cashInGroupA = allocatedGroupA - bonusInGroupA;

  return (
    <div className={s.wrapper}>
      <div className={s.title}> {t('investing:allocation_info.title')}</div>
      <div className={s.block}>
        <div
          className={s.row}
          style={{ cursor: 'pointer' }}
          onClick={() => setHide(!hide)}
        >
          <div className={s.row_left}>
            {t('investing:allocation_info.group_a')}
          </div>
          <div className={s.row_right}>
            <span className="f-500">
              {typeof allocatedGroupA === 'number'
                ? prettyMoney(allocatedGroupA)
                : EMPTY_DASH}
            </span>
            <img
              className={classnames(s.arrow, hide && s.arrow_down)}
              src={IconChevron}
              alt="icon"
              width={20}
              height={20}
            />
          </div>
        </div>
        {typeof allocatedGroupA === 'number' && (
          <div className={classnames(s.dropdown, hide && s.dropdown_hide)}>
            <div className={s.row}>
              <div className={s.row_left}>
                {t('investing:allocation_info.cash')}
              </div>
              <div className={s.row_right}>{prettyMoney(cashInGroupA)}</div>
            </div>
            <div className={s.row}>
              <div className={s.row_left}>
                {t('investing:allocation_info.bonus')}
              </div>
              <div className={s.row_right}>{prettyMoney(bonusInGroupA)}</div>
            </div>
          </div>
        )}
        <div className={s.row}>
          <div className={s.row_left}>
            {t('investing:allocation_info.group_b')}
          </div>
          <div className={s.row_right}>
            <span className="f-500">
              {typeof allocatedGroupB === 'number'
                ? prettyMoney(allocatedGroupB)
                : EMPTY_DASH}
            </span>
          </div>
        </div>
        <div className={s.row}>
          <div className={s.row_left}>
            <span className="f-500">
              {t('investing:allocation_info.total_allocated')}
            </span>
          </div>
          <div className={s.row_right}>
            <span className="f-500">{prettyMoney(totalAllocated)}</span>
          </div>
        </div>
      </div>
    </div>
  );
};
